import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Loader from "../../../../components/common/Loader";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { updateOwner } from "../../../../features/apiCallAdmin";
import { FtextField } from "../../../../components/common/FtextField";

const PayStation = ({ setShow, ispOwner }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  //---> Local State
  const [isLoading, setIsLoading] = useState(false);
  const [passType, setPassType] = useState("password");

  // initial values for form
  let initialValues = {
    storeId: "",
    password: "",
    hasPG: true,
  };

  if (ispOwner) {
    const paymentGateway = ispOwner?.bpSettings?.paymentGateway;
    if (paymentGateway?.payStation) {
      initialValues = {
        storeId: paymentGateway?.payStation?.storeId,
        password: paymentGateway?.payStation?.password,
      };
    }

    if (paymentGateway)
      initialValues = { ...initialValues, hasPG: ispOwner?.bpSettings?.hasPG };
  }

  const ispPayStationValidator = Yup.object({
    storeId: Yup.string().required(t("fieldCannotBeBlank")),
    password: Yup.string().required(t("fieldCannotBeBlank")),
    hasPG: Yup.boolean(),
  });

  const payStationHandler = (values) => {
    let postBody = {
      ...ispOwner,
      bpSettings: {
        ...ispOwner.bpSettings,
        paymentGateway: {
          ...ispOwner.bpSettings.paymentGateway,
          gatewayType: "payStation",
          payStation: {
            storeId: values.storeId,
            password: values.password,
          },
        },
        hasPG: values.hasPG,
      },
    };

    updateOwner(ispOwner.id, postBody, setIsLoading, dispatch, setShow);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={ispPayStationValidator}
      onSubmit={(values) => {
        payStationHandler(values);
      }}
      enableReinitialize
    >
      {() => (
        <Form>
          <div className="displayGrid3">
            <FtextField
              required
              type="text"
              label="Store ID"
              name="storeId"
              validation={true}
            />
            <div>
              <FtextField
                required
                type={passType}
                label="Password"
                name="password"
                validation={true}
              />

              <div className="showPassword">
                <input
                  style={{ cursor: "pointer" }}
                  className="form-check-input shadow-none"
                  type="checkbox"
                  name="showPass"
                  id="showPass"
                  onChange={(e) =>
                    setPassType(e.target.checked ? "text" : "password")
                  }
                />
                <label
                  style={{ cursor: "pointer" }}
                  className="form-check-label text-mute"
                  htmlFor="showPass"
                >
                  &nbsp; Show Password
                </label>
              </div>
            </div>
          </div>

          <div className="displayGrid3">
            <div className="form-check mt-4">
              <Field
                className="form-check-input"
                type="checkbox"
                id="hasPG"
                name="hasPG"
              />
              <label className="form-check-label" for="hasPG">
                Has PG <span className="text-danger me-4">*</span>
              </label>
            </div>
          </div>

          <div className="displayGrid1 float-end mt-4">
            <button
              type="button"
              className="btn btn-secondary"
              disabled={isLoading}
              onClick={() => setShow(false)}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="btn btn-success"
              disabled={isLoading}
            >
              {isLoading ? <Loader /> : "Submit"}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default PayStation;
